import { combineReducers } from "redux";
import accountReducer from "./reducers/accountReducer";
import bankAccReducer from "./reducers/bankAccReducer";
import clientFailedSharesReducer from "./reducers/clientFailedSharesReducer";
import contributorReducer from "./reducers/contributorReducer";
import currencyReducer from "./reducers/currencyReducer";
import dashboardReducer from "./reducers/dashboardReducer";
import distributorReducer from "./reducers/distributorReducer";
import duesReducer from "./reducers/duesReducer";
import incomeShareReducer from "./reducers/incomeShareReducer";
import invoiceReducer from "./reducers/invoiceReducer";
import labelReducer from "./reducers/labelReducer";
import paymentReducer from "./reducers/paymentReducer";
import platformReducer from "./reducers/platformReducer";
import salesDataReducer from "./reducers/salesDataReducer";
import trackReducer from "./reducers/trackReducer";
import userReducer from "./reducers/userReducer";

const rootReducer = combineReducers({
  account: accountReducer,
  bankAcc: bankAccReducer,
  clientFailedShares: clientFailedSharesReducer,
  contributor: contributorReducer,
  currency: currencyReducer,
  incomeShare: incomeShareReducer,
  dues: duesReducer,
  label: labelReducer,
  platform: platformReducer,
  distributor: distributorReducer,
  salesData: salesDataReducer,
  track: trackReducer,
  payment: paymentReducer,
  invoice: invoiceReducer,
  user: userReducer,
  dashboard: dashboardReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
